<template>
    <div    class="w-full">
        <loading    :class="margin"
                    width="w-1/3"
        ></loading>
        <loading    :class="margin"
                    width="w-1/5"
        ></loading>
        <loading    :class="margin"
                    width="w-1/5"
        ></loading>
    </div>
</template>

<script>

import Loading from '@/components/elements/loading'

export default {
    name: "LoadingBlock",
    mixins: [],
    components: {Loading},
    props: {
        margin: {
            type: String,
            default: 'my-2',
        },
    },
    data() {
        return {
            
        }
    },
    created() {
        
    },
    mounted() {
        
    },
    methods: {
        
    },
    computed: {
        
    },
    watch: {
        
    },
}
</script>

<style scoped>

</style>